import {
  GlobeEuropeAfricaIcon,
  ArrowTrendingUpIcon,
  HandThumbUpIcon,
  BookOpenIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  DocumentTextIcon,
  ClipboardIcon,
  ClockIcon,
  InformationCircleIcon,
  BriefcaseIcon,
  BuildingOfficeIcon,
  UserGroupIcon,
  UserIcon,
  ClipboardDocumentListIcon,
  BoltIcon,
  MapPinIcon,
  ArrowLongRightIcon,
  BookmarkIcon,
  ChatBubbleLeftRightIcon,
  LockClosedIcon,
  ShieldCheckIcon,
  HandRaisedIcon,
  MagnifyingGlassIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentIcon,
  ExclamationCircleIcon,
  ArrowLeftIcon,
  HomeIcon,
  HeartIcon,
  BellIcon,
  UsersIcon,
  BuildingOffice2Icon,
  PhoneIcon,
  EnvelopeIcon,
  TrashIcon,
  DevicePhoneMobileIcon,
  CheckCircleIcon as CheckCircleIconOutline,
} from '@heroicons/react/24/outline';
import {
  InformationCircleIcon as InformationCircleSolidIcon,
  ChartBarIcon,
  CalendarIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/solid';

import {
  ApplyMoreFiltersIcon,
  BulbIcon,
  ClipIcon,
  CopyIcon,
  getAssetSrc,
  HouseCheckIcon,
  NOfficeBuildingIcon,
  NoLocationMarkerIcon,
  PrivateModeProtectionCircleIcon,
  PrivateModeProtectionIcon,
} from '@restworld/utils-common';

import { RestartIcon, LocationMarkIcon } from './svg';
import { StandardTitleVariantsProps } from './title.styled-components';

// --> constants
export const titleIconMap = {
  ApplyMoreFiltersIcon: <ApplyMoreFiltersIcon stroke="black" />,
  ArrowLeftIcon: <ArrowLeftIcon className="h-5 w-5 text-black" />,
  ArrowLeftWhiteIcon: <ArrowLeftIcon className="h-5 w-5 text-white" />,
  ArrowLongRightIcon: <ArrowLongRightIcon className="h-5 text-black" />,
  ArrowLongRightPurpleIcon: <ArrowLongRightIcon className="h-5 text-primary-800" />,
  ArrowTrendingUpIcon: <ArrowTrendingUpIcon className="h-5" />,
  BellIcon: <BellIcon className="h-6 w-6 text-gray-500" />,
  BlackBuildingOfficeIcon: <BuildingOfficeIcon className="h-5 text-gray-900" />,
  BoltIcon: <BoltIcon className="h-4" />,
  BookOpenIcon: <BookOpenIcon className="h-5" />,
  BookmarkIcon: <BookmarkIcon className="h-6" />,
  BriefcaseIcon: <BriefcaseIcon className="h-6" />,
  BriefcasePurple800Icon: <BriefcaseIcon className="h-6 w-6 text-primary-800" />,
  BriefcasePurpleIcon: <BriefcaseIcon className="h-6 w-6" />,
  BuildingOfficeBlackIcon: <BuildingOfficeIcon className="h-5 w-5 text-gray-900" />,
  BuildingOfficeGrayIcon: <BuildingOfficeIcon className="h-5 text-gray-500" />,
  BuildingOfficeIcon: <BuildingOfficeIcon className="h-6 w-6 text-primary-800" />,
  BuildingOfficePurpleIcon: <BuildingOfficeIcon className="h-5 text-primary-800" />,
  BuildingOfficeWhiteIcon: <BuildingOfficeIcon className="h-5 text-white" />,
  BulbIcon: <BulbIcon />,
  ChatBubbleLeftRightIcon: <ChatBubbleLeftRightIcon className="h-6 w-6 text-primary-500" />,
  ChatBubbleOvalLeftEllipsisIcon: <ChatBubbleOvalLeftEllipsisIcon className="h-5" />,
  ClockIcon: <ClockIcon className="h-5" />,
  ClockPurpleIcon: <ClockIcon className="h-5 text-primary-800" />,
  ClipboardDocumentCheckGreenIcon: <ClipboardDocumentCheckIcon className="h-6 w-6 text-green-500" />,
  ClipboardDocumentCheckPurpleIcon: <ClipboardDocumentCheckIcon className="h-6 w-6 text-primary-800" />,
  ClipboardDocumentIcon: <ClipboardDocumentIcon className="h-6 w-6 text-primary-800" />,
  ClipboardDocumentListIcon: <ClipboardDocumentListIcon className="h-5" />,
  ClipboardIcon: <ClipboardIcon className="h-5" />,
  CopyIcon: <CopyIcon />,
  DocumentTextIcon: <DocumentTextIcon className="h-5" />,
  ExclamationCircleIcon: <ExclamationCircleIcon className="h-6 w-6 text-primary-800" />,
  GlobeEuropeAfricaIcon: <GlobeEuropeAfricaIcon className="h-5 w-5 text-gray-900" />,
  HandRaiseRedIcon: <HandRaisedIcon className="h-4 w-4 text-red-500" />,
  HandThumbUpIcon: <HandThumbUpIcon className="h-5" />,
  HeartIcon: <HeartIcon className="h-6 w-6 text-primary-800" />,
  HomeIcon: <HomeIcon className="h-6 w-6 text-gray-600" />,
  HomeIconGray: <HomeIcon className="h-5 w-5 text-gray-600" />,
  HouseCheckIcon: <HouseCheckIcon />,
  InformationCircleIcon: <InformationCircleIcon className="h-6" />,
  LockClosedIcon: <LockClosedIcon className="h-6 w-6 text-primary-500" />,
  LocationMarkIcon: <LocationMarkIcon />,
  MagnifyingGlassIcon: <MagnifyingGlassIcon className="h-5 w-5 text-gray-900" />,
  MagnifyingGlassPurpleIcon: <MagnifyingGlassIcon className="h-5 w-5 text-primary-800" />,
  MapIcon: <img src={getAssetSrc('/utils-assets/map-icon.svg')} className="h-6" alt="" />,
  MapPinIcon: <MapPinIcon className="h-5 text-black" />,
  MapPinIconGray: <MapPinIcon className="h-5 text-gray-500" />,
  MapPinIconPurple: <MapPinIcon className="h-5 w-5 text-primary-800" />,
  NOfficeBuildingIcon: <NOfficeBuildingIcon />,
  NoLocationMarkerIcon: <NoLocationMarkerIcon />,
  PaperClipIcon: <ClipIcon />,
  PrivateModeProtectionCircleIcon: <PrivateModeProtectionCircleIcon />,
  PrivateModeProtectionIcon: <PrivateModeProtectionIcon />,
  PrivateModeProtectionPurpleIcon: <PrivateModeProtectionIcon stroke="#693EB5" />,
  RedBuildingOfficeIcon: <BuildingOfficeIcon className="h-6 w-6 text-primary-800" />,
  RestartIcon: <RestartIcon />,
  ShieldCheckIcon: <ShieldCheckIcon className="h-6 w-6 text-primary-500" />,
  SpoonPlateIcon: <img src={getAssetSrc('/utils-assets/spoon-plate.svg')} className="h-7" alt="" />,
  UserGroupIcon: <UserGroupIcon className="h-6 text-gray-600" />,
  UserGroupPurpleIcon: <UserGroupIcon className="h-6 text-primary-800" />,
  UserPurpleIcon: <UserIcon className="h-5 text-primary-800" />,
  InformationCircleBlackIcon: <InformationCircleIcon className="h-6 text-gray-900" />,
  UsersIconOrange: <UsersIcon className="h-6 w-6 text-orange" />,
  BuildingOffice2Icon: <BuildingOffice2Icon className="h-4 w-4 text-neutral-200" />,
  PhoneIcon: <PhoneIcon className="h-4 w-4 text-neutral-200 " />,
  EnvelopeIcon: <EnvelopeIcon className="h-4 w-4 text-neutral-200" />,
  MapPinIconNeutral: <MapPinIcon className="h-4 w-4 text-neutral-200" />,
  InformationCircleSolidBlackIcon: <InformationCircleSolidIcon className="h-5 w-5 fill-neutral-700" />,
  TrashIcon: <TrashIcon className="h-4 w-4" />,
  BriefcaseIconNeutral200: <BriefcaseIcon className="h-4 w-4 text-neutral-200" />,
  MapPinIconNeutral200: <MapPinIcon className="h-4 w-4 text-neutral-200" />,
  DevicePhoneMobileIcon: <DevicePhoneMobileIcon className="h-4 w-4" />,
  WorldIcon: '🌍',
  ClipboardCheckIcon: <ClipboardDocumentCheckIcon className="h-6 w-6" />,
  UsersIconPurple: <UsersIcon className="h-6 w-6 text-purple-700" />,
  ChartBarIcon: <ChartBarIcon className="h-4 w-4 text-neutral-700" />,
  MapPinIconNeutral700: <MapPinIcon className="h-4 w-4 text-neutral-700" />,
  CalendarIcon: <CalendarIcon className="h-4 w-4 text-neutral-700" />,
  CheckCircleIconPurple: <CheckCircleIcon className="h-5 w-5 text-purple-500" />,
  CheckCircleIconSuccess: <CheckCircleIconOutline className="h-6 w-6 text-green-500" />,
};
/**
 * A map of text sizes to Tailwind CSS classes.
 * @property {string} superSuperSuperLarge - The Tailwind CSS class for text size 5xl (48px).
 * @property {string} text-4xl - The Tailwind CSS class for text size 4xl (36px).
 * @property {string} superSuperLarge - The Tailwind CSS class for text size 3xl (30px).
 * @property {string} superLarge - The Tailwind CSS class for text size 2xl (24px).
 * @property {string} extraLarge - The Tailwind CSS class for text size xl (20px).
 * @property {string} large - The Tailwind CSS class for text size lg (18px).
 * @property {string} base - The Tailwind CSS class for text size base (16px).
 * @property {string} small - The Tailwind CSS class for text size sm (14px).
 * @property {string} xSmall - The Tailwind CSS class for text size xs (12px).
 */
export const sizeMap = {
  superSuperSuperLarge: 'text-5xl', // 48
  'text-4xl': 'text-4xl', // 36
  superSuperLarge: 'text-3xl', // 30
  superLarge: 'text-2xl', // 24
  extraLarge: 'text-lg lg:text-xl', //20
  large: 'text-lg', // 18
  base: 'text-base', // 16px
  small: 'text-sm', // 14px
  xSmall: 'text-xs', // 12px
};

export const fontSizeMapToStandard = (size: keyof typeof sizeMap): StandardTitleVariantsProps => {
  switch (size) {
    case 'superSuperSuperLarge':
      return 'display-2';
    case 'text-4xl':
      return 'h1';
    case 'superSuperLarge':
      return 'h2';
    case 'superLarge':
      return 'h3';
    case 'extraLarge':
      return 'h4';
    case 'large':
      return 'h4';
    default:
      return 'h5';
  }
};

/**
 * A map of colors to Tailwind CSS classes.
 * @property {string} black - The Tailwind CSS class for black text.
 * @property {string} gray - The Tailwind CSS class for gray text.
 * @property {string} white - The Tailwind CSS class for white text.
 * @property {string} bold-purple - The Tailwind CSS class for bold purple text.
 * @property {string} red - The Tailwind CSS class for red text.
 * @property {string} secondary - The Tailwind CSS class for secondary text.
 * @property {string} primary-50 - The Tailwind CSS class for primary-50 text.
 * @property {string} grey-900 - The Tailwind CSS class for grey-900 text.
 * @property {string} gray-600 - The Tailwind CSS class for gray-600 text.
 */
export const colorMap = {
  black: 'text-gray-900',
  gray: 'text-gray-500',
  white: 'text-white',
  'bold-purple': 'text-primary-800',
  red: 'text-red-600',
  secondary: 'text-secondary-800',
  'primary-50': 'text-primary-50',
  'grey-900': 'text-gray-900',
  'gray-600': 'text-gray-600',
  'gray-500': 'text-gray-500',
  'gray-900': 'text-gray-900',
  'primary-700': 'text-primary-700',
  'red-800': 'text-red-800',
  'gray-50': 'text-gray-50',
  'gray-400': 'text-gray-400',
  'neutral-200': 'text-neutral-200',
  'neutral-700': 'text-neutral-700',
  'purple-700': 'text-purple-700',
  'orange-700': 'text-orange-700',
  'purple-500': 'text-purple-500',
  'neutral-100': 'text-neutral-100',
  'neutral-10': 'text-neutral-10',
  'green-700': 'text-green-700',
};
/**
 * A map of font weights to Tailwind CSS classes.
 * @property {string} font-bold - The Tailwind CSS class for bold text.
 * @property {string} font-medium - The Tailwind CSS class for medium text.
 * @property {string} font-normal - The Tailwind CSS class for normal text.
 * @property {string} font-light - The Tailwind CSS class for light text.
 * @property {string} font-semibold - The Tailwind CSS class for semibold text.
 * @property {string} font-extrabold - The Tailwind CSS class for extrabold text.
 */
export const fontWeightMap = {
  light: 'font-light', // 300
  normal: 'font-normal', //400
  medium: 'font-medium', // 500
  semibold: 'font-semibold', // 600
  bold: 'font-bold', // 700
  extrabold: 'font-extrabold', // 800
};
